export enum GoverningJurisdictionTypeId {
  Alberta = 1,
  BritishColumbia = 2,
  Manitoba = 3,
  NewBrunswick = 4,
  NewfoundlandAndLabrador = 5,
  NovaScotia = 6,
  Ontario = 8,
  Quebec = 9,
  Saskatchewan = 10,
  Federal = 12
}
